import React, { Component } from 'react';
import Navbar from '../Components/Navbar';
import RegistrationLanding from '../Components/Registration/RegistrationLanding';
import RegistrationLandingHostel from '../Components/Registration/RegistrationLandingHostel';


class RegistrationContainerHostel extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Navbar
          history={this.props.history}
        />
        <div className="main-body">

          <RegistrationLandingHostel
                    history={this.props.history}
          />
        </div>
      </div>
    )
  }
}

export default RegistrationContainerHostel;